import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

const countryLanguageMap = {
    NORWAY: 'no',
    ITALY: 'it',
    GERMANY: 'de',
    FRANCE: 'fr',
    default: 'en',
};

class DealerStore extends StoreModel {
    constructor() {
        super('dealer', {
            namePlural: 'dealers',
            sort: 'customerno',
            api: {
                search: {
                    url: '/api/dealers/',
                    params: {},
                },
                load: {
                    url: '/api/dealers/',
                    params: {},
                },
                save: {
                    url: '/api/dealers/',
                    params: {},
                },
            },
        });
        // const dealer = util.getObject('dealer');
        // this.updateRealdealer(dealer);
    }

    @observable languages = countryLanguageMap;

    @observable dealer = {};

    @observable dealers = [];

    @observable realDealer = {};

    @observable countries = [];

    getElement(idx) {
        const index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            name: this.searchResults[index].name,
            customerno: this.searchResults[index].customerno,
            email: this.searchResults[index].email,
        };
    }

    @action
    updateItem(dealer) {
        this.dealer = dealer;
        if (!this.dealer.settings) {
            this.dealer.settings = {};
        }
        if (this.dealer.country) {
            this.dealer.countryCode = this.dealer.settings.language || countryLanguageMap[this.dealer.country];
        }
    }

    @action
    updateRealdealer(dealer) {
        this.realDealer = dealer;
        if (!this.realDealer.settings) {
            this.realDealer.settings = {};
        }
        if (this.realDealer.country) {
            this.realDealer.countryCode = this.realDealer.settings.language || countryLanguageMap[this.realDealer.country];
        }
    }

    @action
    updateCountries(countries) {
        this.countries = countries;
    }

    async saveField(customerno, field, value, updateMemory) {
        if (updateMemory) {
            this.updateField(customerno, field, value, 'customerno');
        }
        this.updateSaved(`${field}.${customerno}`, true);
        const response = await util.fetchApi(`/api/dealers/${customerno}`, {
            publish: true,
            method: 'PATCH',
        }, {
            [field]: value,
        });
        if (response.status < 300) {
            // Remove saved
            setTimeout(() => {
                this.updateSaved(`${field}.${customerno}`);
            }, 2000);
        }
    }

    // async load(customerno) {
    //     const response = await util.fetchApi(`/api/dealers/${customerno}`, { publish: true });
    //     if (response.data) {
    //         this.updateItem(response.data);
    //     }
    // }

    async loadRealdealer() {
        const response = await util.fetchApi(`/api/dealers/info`, { publish: true });
        if (response.data) {
            this.updateRealdealer(response.data);
            util.setObject('dealer', response.data);
        }
    }

    // async list(append = false) {
    //     if (!append) {
    //         this.updateOffset(0);
    //     }
    //     const response = await util.fetchApi('/api/dealers/', { publish: true }, {
    //         offset: this.offset,
    //         limit: this.limit,
    //         sort: this.sort,
    //         ...this.queryFilter,
    //     });
    //     if (response.data) {
    //         this.update(response.data, append);
    //         if (append) {
    //             this.updateTotalAppend(response.total);
    //         } else {
    //             this.updateTotal(response.total);
    //             this.updateCountries(response.countries);
    //             window.scrollTo(0, 0);
    //         }
    //     }
    // }

    async sendEmail(params) {
        await util.fetchApi(`/api/email`,
            { publish: true, method: 'POST' }, {
                from: 'web@flyfisheurope.com',
                to: this.dealer.email,
                ...params,
            });
    }

    async save(data) {
        await util.fetchApi(`/api/dealers/${this.dealer.customerno}`,
            { publish: true, method: 'PATCH' }, {
                ...data,
            });
    }
}

const store = new DealerStore();
export default store;



// WEBPACK FOOTER //
// ./stores/dealer.js